import { RouteConfig, Location } from "vue-router/types/router";

import { TagData } from '../../../../components/Tags/types'
import { AnyValue } from "../../../../shared/types/AnyValue";
import { VueComponent } from "../../../../shared/types/VueComponent";
import TemplateContext from "../../includes/TemplateContext";

export type TemplateRoute = RouteConfig
export type TemplateRoutes = Array<TemplateRoute>

export enum MenuItemTypeEnum {
  Route = 'Route',
  Dropdown = 'Dropdown',
  DynamicHeader = 'DynamicHeader',
  Divider = 'Divider',

  Component = 'Component',
  Link = 'Link',
  Button = 'Button',
}

export type TemplateMenuConfigBaseFields = {
  isVisible?: Array<AnyValue<boolean, TemplateContext | null>>
  alias?: string
  tags?: Array<AnyValue<TagData | null, TemplateContext | null>>,
  class?: Array<AnyValue<string, TemplateContext | null>>
  icon?: {
    iconType: 'material-icons' | 'feather',
    name: string,
  }
}

//DynamicHeader
export type TemplateConfigDynamicHeaderFields = {
  type: MenuItemTypeEnum.DynamicHeader
  route?: Location
  title: AnyValue<string, TemplateContext | null>
  img: AnyValue<string, TemplateContext | null>
}
export type TemplateConfigDynamicHeader = TemplateConfigDynamicHeaderFields & Omit<TemplateMenuConfigBaseFields, | 'alias'>

// route
export type TemplateConfigRouteFields = {
  type: MenuItemTypeEnum.Route,
  route: AnyValue<Location>
}
export type TemplateConfigRoute = TemplateConfigRouteFields & TemplateMenuConfigBaseFields

// dropdown
export type TemplateConfigDropdownFields = {
  type: MenuItemTypeEnum.Dropdown,
  guid: string
  children: TemplateMenuConfigItems
  selected?: Array<AnyValue<boolean, TemplateContext | null>>
}
export type TemplateConfigDropdown = TemplateConfigDropdownFields & TemplateMenuConfigBaseFields

// Divider
export type TemplateConfigDividerFields = {
  type: MenuItemTypeEnum.Divider
}
export type TemplateConfigDivider = TemplateConfigDividerFields & Pick<TemplateMenuConfigBaseFields, 'isVisible' | 'class' | 'alias'>

// Component
export type TemplateConfigComponentFields = {
  type: MenuItemTypeEnum.Component
  component: VueComponent
} & Omit<TemplateMenuConfigBaseFields, 'tags'>

// Link
export type TemplateConfigLinkFields = {
  type: MenuItemTypeEnum.Link
  route?: Location
  href?: AnyValue<string>
  onClick?: (ctx: TemplateContext | null) => void
} & TemplateMenuConfigBaseFields

// Button
export type TemplateConfigButtonFields = {
  type: MenuItemTypeEnum.Button
  antType: string
  antSize: string
  antIcon?: string
} & Pick<TemplateConfigLinkFields, 'route' | 'href' | 'onClick'> & Omit<TemplateMenuConfigBaseFields, 'tags'>

//
export type TemplateMenuConfigItem = TemplateConfigRoute
  | TemplateConfigDynamicHeader
  | TemplateConfigDropdown
  | TemplateConfigDivider
  | TemplateConfigComponentFields
  | TemplateConfigLinkFields
  | TemplateConfigButtonFields

export type TemplateMenuConfigItems = Array<TemplateMenuConfigItem | (() => Array<TemplateMenuConfigItem>)>

export type BaseTemplateConfig = {
  routes: TemplateRoutes
  sidebar: TemplateMenuConfigItems
  navbar: TemplateMenuConfigItems
}

